<template>
  <div class="goods__list">
    <SearchNav :search="searchClass" @change="changeSearchClass" />
    <div class="goods__list__search">
      <div
        @click="clickSaleSort(item.sortType)"
        class="sort__btn vertical-align pointer select"
        v-for="item in sortTypes"
        :key="item.sortType"
      >
        <span :class="{ middle: true, active__search: activeSearch == item.sortType }">
          {{ item.sortInfo }}
        </span>
        <img
          v-if="item.sortType !== 1 && item.sortType !== 4"
          class="middle sort__icon"
          :src="item.sortType == activeSearch ? upToLowActive : upToLow"
        />
        <img
          v-if="item.sortType === 4"
          class="middle sort__icon"
          :src="item.sortType == activeSearch ? lowToUpActive : lowToUp"
        />
      </div>
      <!-- <div @click="clickSaleSort" class="sort__btn vertical-align pointer select">
        <span :class="{ middle: true, active__search: activeSearch == 'sale' }">
          销量
        </span>
        <img class="middle sort__icon" :src="sale" />
      </div>
      <div @click="clickSaleSort" class="sort__btn vertical-align pointer select">
        <span :class="{ middle: true, active__search: activeSearch == 'sale' }">
          价格
        </span>
        <img class="middle sort__icon" :src="sale" />
      </div> -->
      <el-checkbox-group @change="changeActivityLabel" v-model="activityLabel">
        <el-checkbox
          v-for="active in searchClass.itemAggActivityLabels || []"
          :label="active"
          :key="active"
        ></el-checkbox>
      </el-checkbox-group>
    </div>

    <div class="goods__list__display flex wrap">
      <template v-if="goodsList.length">
        <GoodsInfo
          class="pointer"
          v-for="goods in goodsList"
          :key="goods.itemCode"
          :goods="goods"
          @update-cart="updateCart"
          :itemStyle="itemStyle"
          :purchaseAble="true"
          @click-goods="linkToGoodsDetails(goods.itemCode)"
        />
      </template>
      <div class="empty" v-else>
        <img class="empty__logo" src="@/assets/img/shop-empty.png" />
        <div class="empty__text">暂无商品</div>
      </div>
    </div>
    <el-pagination
      style="text-align: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchParams.pageNo"
      :page-size="searchParams.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>

<script>
import * as api from '@/services';
import SearchNav from '../components/SearchNav';
import GoodsInfo from '@/components/GoodsInfo';

const upToLowActive = require('@/assets/search/up-to-low-active.png');
const upToLow = require('@/assets/search/up-to-low.png');
const lowToUpActive = require('@/assets/search/low-to-up-active.png');
const lowToUp = require('@/assets/search/low-to-up.png');

export default {
  components: {
    SearchNav,
    GoodsInfo
  },
  watch: {
    $route: function() {
      this.firstFlag = true;
      this.getList();
    }
  },
  computed: {
    searchText() {
      return this.$route.query.text || '';
    },
    searchClassCode() {
      return this.$route.query.code || '';
    }
  },
  mounted() {
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-ssy-ssjgyB2B'
    })
  },
  inject: ['home'],
  data() {
    return {
      upToLowActive,
      upToLow,
      lowToUpActive,
      lowToUp,
      firstFlag: true,
      // 筛选条件
      activeSearch: 1,
      activityLabel: [],
      // 商品列表相关
      searchParams: {
        key: '',
        pageNo: 1,
        pageSize: 12,
        // 排序类型：1-综合排序，2-销量排序，3-月销店数降序
        orderType: 1,
        // 是否需要商品聚合信息
        aggregateFlag: true,
        itemActivityLabel: null,
        categoryCode: null,
        itemFactoryNames: null,
        itemSpecs: null,
        shopId: null
      },
      totalCount: 0,
      goodsList: [],
      searchClass: {
        itemAggFactoryNames: [],
        itemCategories: [],
        merchantAggInfos: [],
        specsAgg: []
      },
      itemStyle: {
        margin: '0 6px 16px 6px',
        marginBottom: '16px',
        height: '450px'
      },
      sortTypes: []
    };
  },
  methods: {
    updateCart() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ssy-ssjgydjjganB2B',
        // custom: {
        //   goodsCode: this.goods.itemCode,
        //   goodsName: this.goods.itemTitle,
        //   tabName: '商城首页',
        //   tabIndex: 0
        // }
      })

      // 加购成功获取购物车数量
      this.$emit('update-cart');
    },
    linkToGoodsDetails(id) {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ssy-ssjgydjspanB2B',
        // custom: {
        //   goodsCode: this.goods.itemCode,
        //   goodsName: this.goods.itemTitle,
        //   tabName: '商城首页',
        //   tabIndex: 0
        // }
      })

      const search = this.home.$refs.search;
      search && search.clear();
      this.$router.push({ path: `/goodsDetails/${id}` });
    },
    clickSaleSort(type) {
      this.activeSearch = type;
      this.searchParams.orderType = type;
      this.changeGetGoodsList();
    },
    // 更新搜索条件类目
    autoChangeSearchClass({ chooseFactoryValue, chooseShopValue, chooseSpecValue, chooseCategoryCode }) {
      this.searchParams.itemFactoryNames = chooseFactoryValue || null;
      this.searchParams.shopId = chooseShopValue || null;
      this.searchParams.itemSpecs = chooseSpecValue.join() || null;
      this.searchParams.categoryCode = chooseCategoryCode || null;
    },

    changeSearchClass(chooseClass) {
      this.autoChangeSearchClass(chooseClass);
      this.changeGetGoodsList();
    },
    changeActivityLabel() {
      this.searchParams.itemActivityLabel = this.activityLabel.join() || null;
      this.changeGetGoodsList();
    },
    async getList() {
      const params = {
        ...this.searchParams,
        key: this.searchText || null,
        categoryCode: this.searchClassCode || null,
        skuId: this.$route.query.skuId || null,
        saleOutStatus: 2, // 查询售罄状态： 0 未售罄 1售罄 2全部(未售罄+售罄) 默认 0 未售罄
      };
      const {
        data: { itemAggInfo, itemBasicInfos },
        totalRecord
      } = await api.goods.getGoodsList(params);
      this.goodsList = itemBasicInfos;
      this.totalCount = totalRecord;
      if (this.firstFlag) {
        this.searchClass = itemAggInfo;
        this.searchClass.itemAggActivityLabels = ['特价'];
      }
      this.firstFlag = false;
    },
    async getSortType() {
      const { sortTypes } = await api.goods.getSearchSortType({ orderCategory: 1 });
      this.sortTypes = sortTypes;
    },
    // 条件变更时获取新的商品列表
    changeGetGoodsList() {
      this.searchParams.pageNo = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getList();
    }
  },
  created() {
    this.getList();
    this.getSortType();
  }
};
</script>

<style lang="scss" scoped>
.goods__list {
  &__search {
    height: 48px;
    margin-top: 12px;
    padding: 10px 16px;
    background: #f5f5f5;
    border: 1px solid #eeeeee;
  }
  .sort {
    &__icon {
      width: 6px;
      height: 12px;
    }
    &__btn {
      margin-right: 10px;
      display: inline-block;
      height: 28px;
      padding: 7px 12px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 12px;
      border: 1px solid #dedede;
      background: #ffffff;
      &:hover {
        color: #1e8dff;
        border-color: #1e8dff;
      }
    }
  }
  .active__search {
    color: #1e8dff;
  }
  &__display {
    min-height: 460px;
    margin-top: 16px;
  }
  ::v-deep .el-checkbox-group {
    display: inline-block;
    // margin-left: 8px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
    line-height: 1;
  }
  .empty {
    flex: 1;
    padding-top: 60px;
    text-align: center;
    background: #f5f5f5;
    &__logo {
      width: 220px;
      height: 220px;
    }
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
}
</style>
